import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Icon, Text } from '@ui-kitten/components';

import { EventDetails } from '../../RTK/api/events/types';
import themeStyle from '../../Theme/styles';
import Image from '../../Components/Image';
import { formatDistanceFromMeters } from '../../Helper';
import Button from '../../Components/Button';

const ReservationCardSmall = ({
  loading,
  store,
  onPress,
}: EventDetails & { loading?: boolean; onPress: () => void }) => {
  if (loading) return null;
  return (
    <Button onPress={onPress} plain>
      <View style={styles.wrapper}>
        <Image
          source={{ uri: store.partner_banner }}
          style={{ aspectRatio: 1.82 / 1 }}
        />
        <View style={styles.contentContainer}>
          <Text category="h6" style={themeStyle.spacingBottomSmall}>
            {store.name}
          </Text>
          <Text appearance="hint" style={themeStyle.spacingBottomSmall}>
            {formatDistanceFromMeters(store.distance)}{' '}
            {store.store_tags.join(' · ')}
          </Text>
          <View style={themeStyle.alignItemsEnd}>
            <Button
              accessoryRight={(props) => (
                <Icon
                  {...props}
                  name="chevron-right"
                  style={[props.style, { marginHorizontal: 0 }]}
                />
              )}
              status="info"
              style={{ borderRadius: 5 }}
              size="small"
              onPress={onPress}
            >
              Reserve
            </Button>
          </View>
        </View>
      </View>
    </Button>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    ...themeStyle.shadow,
    ...themeStyle.pageBackground,
    width: 313,
    borderRadius: 8,
    overflow: 'hidden',
  },
  contentContainer: {
    ...themeStyle.pageHorizontalSpacingSmall,
    ...themeStyle.pageVerticalSpacingMedium,
  },
});

export default React.memo(ReservationCardSmall);
